// extracted by mini-css-extract-plugin
export default {"header":"ModalHeader_header__AKxfR","closeBtn":"ModalHeader_closeBtn__J48yN"};